import { Grid } from "@mui/material";
import GenericCard from "./GenericCard";
import { useContext } from "react";
import { EcUserDataContext } from "@eclear-ag/ec-common-ui";
import Revenue from "../revenue";
import TopTable from "../TopTable";
import { Box } from "@mui/system";
import EuSalesDistribution from "../eu-sales-distribution";
import ValidTaxRateCard from "./ValidTaxRateCard";
import { URLS } from "../../configuration/urls";
import { canAccessClearCustoms } from "../../pages/ClearCustoms/tools/tool";

export function WidgetsCards({ gridConfig }) {
  const { userData } = useContext(EcUserDataContext);
  const userSubs = userData?.userInfo?.userSubscriptions;

  const isLoading = userSubs == null;
  const isSubscribedToClearCustoms = canAccessClearCustoms({ userData });

  if (isLoading) {
    return null;
  }

  return (
    <>
      {!isSubscribedToClearCustoms && (
        <>
          <Grid container spacing={3}>
            <Grid
              item
              xs={gridConfig.topCards.xs}
              sm={gridConfig.topCards.sm}
              md={gridConfig.topCards.md}
              lg={gridConfig.topCards.lg}
            >
              <GenericCard
                titleId="revenueActualMonth"
                dataPath="month.total_revenue"
                showCurrency={true}
                tooltipAbsoluteId="revenueActualMonth.absoluteNumber"
                tooltipPercentId="revenueActualMonth.percentFigure"
                data-testid="revenue_actual_month"
              />
            </Grid>
            <Grid
              item
              xs={gridConfig.topCards.xs}
              sm={gridConfig.topCards.sm}
              md={gridConfig.topCards.md}
              lg={gridConfig.topCards.lg}
            >
              <GenericCard
                titleId="totalRevenueThisYear"
                dataPath="year.total_revenue"
                showCurrency={true}
                tooltipAbsoluteId="totalRevenueThisYear.absoluteNumber"
                tooltipPercentId="totalRevenueThisYear.percentFigure"
                data-testid="total_revenue_year"
              />
            </Grid>
            <Grid
              item
              xs={gridConfig.topCards.xs}
              sm={gridConfig.topCards.sm}
              md={gridConfig.topCards.md}
              lg={gridConfig.topCards.lg}
            >
              <GenericCard
                titleId="invoicedOrdersThisYear"
                dataPath="year.invoice_count"
                showCurrency={false}
                tooltipAbsoluteId="invoicedOrdersThisYear.absoluteNumber"
                tooltipPercentId="invoicedOrdersThisYear.percentFigure"
                data-testid="invoiced_orders_year"
              />
            </Grid>
            <Grid
              item
              xs={gridConfig.topCards.xs}
              sm={gridConfig.topCards.sm}
              md={gridConfig.topCards.md}
              lg={gridConfig.topCards.lg}
            >
              <GenericCard
                titleId="averageInvoicedOrderValue"
                dataPath="year.average_revenue"
                showCurrency={true}
                tooltipAbsoluteId="averageInvoicedOrderValue.absoluteNumber"
                tooltipPercentId="averageInvoicedOrderValue.percentFigure"
                data-testid="average_order_value"
              />
            </Grid>
          </Grid>

          <Box style={{ margin: "24px 0px 24px 0px" }}>
            <Revenue />
          </Box>
          <Grid container spacing={3}>
            <Grid
              item
              xs={gridConfig.tables.xs}
              sm={gridConfig.tables.sm}
              md={gridConfig.tables.md}
            >
              <TopTable
                dataUrl={URLS.TOTAL_REVENUE_TOP_COUNTRY}
                titleId="topCountries"
                tooltipTextId="topCountries.popup.text"
                csvLink="export/dashboard/tables/top-n-countries"
                fileName="topCountries"
                className="top-countries"
                type="countries"
                testIdPrefix="top_countries"
              />
            </Grid>
            <Grid
              item
              xs={gridConfig.tables.xs}
              sm={gridConfig.tables.sm}
              md={gridConfig.tables.md}
            >
              <TopTable
                dataUrl={URLS.TOTAL_REVENUE_TOP_PRODUCT}
                titleId="topProducts"
                tooltipTextId="topProducts.popup.text"
                csvLink="export/dashboard/tables/top-n-products"
                fileName="topProducts"
                className="top-products"
                type="products"
                testIdPrefix="top_products"
              />
            </Grid>
          </Grid>
          <Box style={{ margin: "24px 0px 24px 0px" }}>
            <EuSalesDistribution />
          </Box>
          <Grid container spacing={3} style={{ marginBottom: "24px" }}>
            <Grid
              item
              xs={gridConfig.taxRateCards.xs}
              sm={gridConfig.taxRateCards.sm}
              md={gridConfig.taxRateCards.md}
              lg={gridConfig.taxRateCards.lg}
            >
              <ValidTaxRateCard
                dataPath="invoice_valid_tax_count"
                titleId="invoicesWithValidTaxRates"
                tooltipAbsoluteId1="invoicesWithValidTaxRates.absoluteNumber1"
                tooltipAbsoluteId2="invoicesWithValidTaxRates.absoluteNumber2"
                testIdPrefix="invoices_with_valid_tax_rates"
              />
            </Grid>
            <Grid
              item
              xs={gridConfig.taxRateCards.xs}
              sm={gridConfig.taxRateCards.sm}
              md={gridConfig.taxRateCards.md}
              lg={gridConfig.taxRateCards.lg}
            >
              <ValidTaxRateCard
                dataPath="product_valid_tax_count"
                titleId="invoicedProductsWithValidTaxRates"
                tooltipAbsoluteId1="invoicedProductsWithValidTaxRates.absoluteNumber1"
                tooltipAbsoluteId2="invoicedProductsWithValidTaxRates.absoluteNumber2"
                testIdPrefix="invoiced_products_with_valid_tax_rates"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid
              item
              xs={gridConfig.vatAmountCards.xs}
              sm={gridConfig.vatAmountCards.sm}
              md={gridConfig.vatAmountCards.md}
              lg={gridConfig.vatAmountCards.lg}
            >
              <GenericCard
                titleId="overallVatAmountThisMonth"
                dataPath="month.total_vat"
                showCurrency={true}
                tooltipAbsoluteId="overallVatAmountThisMonth.absoluteNumber"
                tooltipPercentId="overallVatAmountThisMonth.percentFigure"
                containerClass="widget-col-6"
                data-testid="vat_amount_current_month"
              />
            </Grid>
            <Grid
              item
              xs={gridConfig.vatAmountCards.xs}
              sm={gridConfig.vatAmountCards.sm}
              md={gridConfig.vatAmountCards.md}
              lg={gridConfig.vatAmountCards.lg}
            >
              <GenericCard
                titleId="overallVatAmountThisYear"
                dataPath="year.total_vat"
                showCurrency={true}
                tooltipAbsoluteId="overallVatAmountThisYear.absoluteNumber"
                tooltipPercentId="overallVatAmountThisYear.percentFigure"
                containerClass="widget-col-6"
                data-testid="vat_amount_current_year"
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
